import DetailPageComponent from './DetailPageComponent';
export default DetailPageComponent;
